import { render } from "./CourseTypeDistributionChart.vue?vue&type=template&id=d5d12eee"
import script from "./CourseTypeDistributionChart.vue?vue&type=script&lang=js"
export * from "./CourseTypeDistributionChart.vue?vue&type=script&lang=js"
script.render = render

export default script